import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createRouter, RootComponent } from "./router";
import { initApp } from "./apps";
import configureStore from "./store";

import "./styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const init = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  // Create a router from app routes
  const router = createRouter();
  const store = configureStore(router);

  initApp(store);

  router.start((err, state) => {
    ReactDOM.render(
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <RootComponent />
        </Provider>
        <ReactQueryDevtools />
      </QueryClientProvider>,
      document.getElementById("app")
    );
  });
};

init();
